import { environment } from 'src/environments/environment';
import { AppSettings } from './store.settings';

export const appStoreSettingsIS: AppSettings = {
  language: 'es',
  format: 'units',
  precision: 0,
  scale: environment.defaultFontSize,
};
